/**
 * @generated SignedSource<<4f1cf8c742ac61ae998ce1afd511481d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestions_periscope_WorkSuggestionsSwitcher_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"blockingIssue_periscope_BlockingIssueTask" | "criticalVulnerability_periscope_SecurityVulnerabilityTask" | "failedBuild_periscope_FailedBuildTask" | "failedDeployment_periscope_FailedDeploymentTask" | "pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask" | "pullRequestReview_periscope_PullRequestReviewTask">;
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsSwitcher_node";
};
export type suggestions_periscope_WorkSuggestionsSwitcher_node$key = {
  readonly " $data"?: suggestions_periscope_WorkSuggestionsSwitcher_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsSwitcher_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "suggestions_periscope_WorkSuggestionsSwitcher_node",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "failedBuild_periscope_FailedBuildTask"
        }
      ],
      "type": "WorkSuggestionsBuildTask"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "failedDeployment_periscope_FailedDeploymentTask"
        }
      ],
      "type": "WorkSuggestionsDeploymentTask"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "pullRequestReview_periscope_PullRequestReviewTask"
        }
      ],
      "type": "WorkSuggestionsPullRequestReviewTask"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask"
        }
      ],
      "type": "WorkSuggestionsPullRequestNeedsWorkTask"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "criticalVulnerability_periscope_SecurityVulnerabilityTask"
        }
      ],
      "type": "WorkSuggestionsCriticalVulnerabilityTask"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "blockingIssue_periscope_BlockingIssueTask"
        }
      ],
      "type": "WorkSuggestionsBlockingIssueTask"
    }
  ],
  "type": "WorkSuggestionsCommon",
  "abstractKey": "__isWorkSuggestionsCommon"
};

(node as any).hash = "5e056ec4896e9137a6c1dfcd67f64ac4";

export default node;
